import { render, staticRenderFns } from "./StatsLastReviewsLogoModal.vue?vue&type=template&id=6e5f88a4&"
import script from "./StatsLastReviewsLogoModal.vue?vue&type=script&lang=js&"
export * from "./StatsLastReviewsLogoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports